import React, { useState, useEffect } from 'react'
import API from '../../../../config/api';
import swal from 'sweetalert';
import {
    Attachment, AttachmentImage, BackArrow, Container, Header,
    Label, ModalContainer, Section, TitleHeader,
    UpdateButton, Value
} from '../components/ModalReimbusement';
import styled from 'styled-components';
import { FInput } from '../components/tambahTugas';
import { Loading } from '../../../../components';

const TextArea = styled.textarea`
  width: 100%;
  min-height: 80px;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 14px;
  margin-top: 8px;
  resize: vertical;
`;

const ModalDetail = (props) => {
    const { openModal, handlCLose, data, getReimbursement, setData, setTypeModal, employee } = props
    const token = localStorage.getItem('token')

    const [paymentMethod, setPaymentMethod] = useState('');
    const [referenceCode, setReferenceCode] = useState('');
    const today = new Date().toISOString().split('T')[0];
    const [tanggalPaid, setTanggalPaid] = useState(today);
    const [loading, setLoading] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [previewImage, setPreviewImage] = useState(null);
    const [loadingPost, setLoadingPost] = useState(false);
    useEffect(() => {
        if (data) {
            setPaymentMethod(data.payment_method || '');
            setReferenceCode(data.reference_code || '');
            setTanggalPaid(data.paid_at || today);
        }
    }, [data]);

    const onClose = () => {
        handlCLose();
        setData('');
        setPaymentMethod('');
        setReferenceCode('');
        setTanggalPaid('');
    }

    const formatRupiah = (number) => {
        return new Intl.NumberFormat("id-ID", {
            style: "currency",
            currency: "IDR",
            minimumFractionDigits: 0
        }).format(number);
    };

    const formatTanggalIndonesia = (tanggalString) => {
        const tanggal = new Date(tanggalString);
        return new Intl.DateTimeFormat('id-ID', {
            weekday: 'long',
            day: '2-digit',
            month: 'long',
            year: 'numeric'
        }).format(tanggal);
    };

    const handleStatus = () => {
        // Validasi input
        if (!tanggalPaid) {
            swal("Validasi Gagal", "Tanggal penggantian biaya harus diisi.", "warning");
            return;
        }

        if (!selectedImage) {
            swal("Validasi Gagal", "Bukti pembayaran harus diupload.", "warning");
            return;
        }

        setLoadingPost(true);
        const payload = new FormData();
        payload.append('image_bukti', selectedImage);
        payload.append('paid_at', tanggalPaid);
        if (selectedImage) {
            payload.append('image_bukti', selectedImage);
        }
        API.editStatusReimbursementPaid(token, data?.id, payload, employee?.id)
            .then(res => {
                swal("Berhasil", "Data pembayaran berhasil diupdate", "success");
                setSelectedImage(null)
                setPreviewImage(null)
                getReimbursement();
                onClose();
                setLoadingPost(false)
            })
            .catch(err => {
                swal("Gagal", "Terjadi kesalahan saat mengupdate data pembayaran", "error");
                setLoadingPost(false)
            })
            .finally(() => {
                setLoadingPost(false)
            });
    }

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedImage(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviewImage(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };



    return (
        openModal && (
            <>
                <ModalContainer>
                    <Container>
                        <Header>
                            <BackArrow onClick={onClose}>&#8592;</BackArrow>
                            <TitleHeader>Reimbursement Details</TitleHeader>
                        </Header>

                        <Section>
                            <Label>Nama Karyawan</Label>
                            <Value>{data?.name}</Value>
                        </Section>
                        <Section>
                            <Label>Nominal</Label>
                            <Value>{formatRupiah(data?.amount)}</Value>
                        </Section>
                        <Section>
                            <Label>Tanggal Pengeluaran</Label>
                            <Value>{formatTanggalIndonesia(data?.date_incurred)}</Value>
                        </Section>
                        <Section>
                            <Label>Keterangan Pengganti</Label>
                            <Value>{data?.description}</Value>
                        </Section>
                        <Section>
                            <Label>Rekening Karyawan</Label>
                            <Value>{data?.bank_name} - {data?.number} a/n {data?.account_name}</Value>
                        </Section>

                        {/* <Section style={{ width: "105%" }}>
                            <Label>Nama Bank / Payment Method</Label>
                            <FInput
                                type="text"
                                value={paymentMethod}
                                onChange={(e) => setPaymentMethod(e.target.value)}
                                placeholder="Masukkan nama bank..."

                            />
                        </Section>

                        <Section style={{ width: "105%" }}>
                            <Label>Kode Referensi</Label>
                            <FInput
                                type="text"
                                value={referenceCode}
                                onChange={(e) => setReferenceCode(e.target.value)}
                                placeholder="Masukkan kode referensi..."
                            />
                        </Section> */}

                        <Section style={{ width: "105%" }}>
                            <Label>Tanggal Penggantian Biaya</Label>
                            {
                                data.paid_at ? formatTanggalIndonesia(data.paid_at) :
                                    <FInput
                                        type="date"
                                        value={tanggalPaid}
                                        onChange={(e) => setTanggalPaid(e.target.value)}
                                    />
                            }
                        </Section>
                        {
                            !data?.paid_at &&
                            <>
                                <Section>
                                    <Label>Upload Bukti Pembayaran</Label>
                                    <FInput
                                        type="file"
                                        accept="image/*"
                                        onChange={handleImageChange}
                                        style={{ width: "90%" }}
                                    />
                                    {previewImage && (
                                        <Attachment style={{ marginTop: '10px' }}>
                                            <AttachmentImage src={previewImage} alt="Preview" />
                                        </Attachment>
                                    )}
                                </Section>
                                <Section>
                                    <UpdateButton onClick={handleStatus} disabled={loading}>
                                        {loading ? 'Proses...' : 'Sudah Dibayarkan'}
                                    </UpdateButton>
                                </Section>
                            </>
                        }


                        <Section style={{ marginBottom: "150px" }}>
                            <Label>Lampiran</Label>
                            {data?.attachments?.map((at, i) => (
                                <Attachment key={i}>
                                    <AttachmentImage src={at?.file_url} />
                                </Attachment>
                            ))}
                        </Section>
                        <div style={{ position: "fixed", top: "0", right: "0", background: "#00000027", zIndex: "10000", width: "100%", height: "100vh", display: loadingPost ? 'inline' : "none" }}>
                            <Loading />
                        </div>
                    </Container>
                </ModalContainer>
            </>
        )
    );
}

export default ModalDetail;
